import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/templates(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TemplatesContainer',
      './modules/templates'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Templates = require('./containers/TemplatesContainer').default
      const actions = require('./modules/templates')
      const reducer = require('./modules/templates').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'practiceTemplate', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId, nextState.params.view))

      /*  Return getComponent   */
      cb(null, Templates)

    /* Webpack named bundle   */
    }, 'practiceTemplate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/ConnectionTemplates/index.js